
import {Controller as GroupController} from './../../../../../zviz2/zviz/components/group';
import {extend, cloneObject} from './../../../../../zviz2/zviz/functions';

import Vector2 from './../../../../../zviz2/zviz/math/vector2';
import MapItem from './item';
import state from './../../../../../zviz2/zviz/state';


class Controller extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);
        
        this.nonGeographicCentroids = new Map();

        this.infoBoxes = new Map();
        
    }

    getNonGeoData(value, dimension){
        let c = new Vector2(0, 0);
        let key = dimension + '.' + value;
        if(this.nonGeographicCentroids.has(key)){
            c = this.nonGeographicCentroids.get(key).copy();
        }else{
            c.y = this.data.height - 30;
            c.x = 30;
            let w = 230;
            let h = 65;
            for(let [k, v] of this.nonGeographicCentroids){
                c.x = v.x + w;
                c.y = v.y;
            }
            if(c.x + w > this.data.width){
                c.y -= h;
                c.x = 30;
            }
            this.nonGeographicCentroids.set(key, c);
        }
        return {
            ids: [],
            centroid: c,
            notOnMap: true
        };
    }

    getLocation(value, dimension, full=false){
        let geoData = this.models['geo'].getGeoData(value, dimension);
        if(geoData == null){
            geoData = this.getNonGeoData(value, dimension);
        }
        if(! full){
            return geoData.centroid;
        }
        return geoData;
    }

    getChildren(){

        if(this.models['geo'].status != 'success'){
            return [];
        }

        let result = [];
        this.nonGeographicCentroids = new Map();
        let infoBoxes = [];

        let items = this.data.selected;
        let highlight = state.get('map.countryHighlight');

        for(let item of items){
            let geoData = this.getLocation(item.value, item.type, true);
            let align = 'left';

            if(! geoData.notOnMap && geoData.centroid.x > 0.5 * this.data.width && 
                    geoData.centroid.x > this.data.width - 160){
                align = 'right';
            }
            item.size = 1;
            if(highlight){
                let d = {id3: geoData.ids.slice(0,1)};
                if(highlight.type == 'region'){
                    d = {region: item.value};
                }
                
                if(this.models['geo'].isInSelection(d, highlight)){
                    item.size = 2;
                }
            }

            let uid = this.uid + '_mi.' + item.type + '.' + item.value;
            result.push(extend({
                uid: uid,
                properties: {
                    data: {
                        item: extend(item, geoData),
                        coords: [geoData.centroid.x, geoData.centroid.y],
                        countries: geoData.ids,
                        notOnMap: geoData.notOnMap || false,
                        align: align,
                        parentUid: this.uid,
                        projectIcon: this.data.projectIcon
                    }
                }
            }, MapItem));

            infoBoxes.push({
                pos: [geoData.centroid.x, geoData.centroid.y],
                size: item.size || 0,
                align: align,
                uid: uid,
                show: true
            });

        }

        // largest item should be placed first so that smaller will not disappear behind it
        result.sort(function(a, b){
            if(a.properties.data.item.size <= b.properties.data.item.size){
                return 1;
            }
            return -1;
        });

        this.setVisibilityInfoBoxes(infoBoxes);

        return result;

    }

    showInfoBox(uid){
        return this.infoBoxes.get(uid);
    }

    /**
     * TODO: for pins the boxes are placed a little higher
     */
    setVisibilityInfoBoxes(boxes){
        boxes.sort(function(a, b){
            if(a.align == 'left' && b.align == 'right'){
                return 1;
            }else if(a.align == 'right' && b.align == 'left'){
                return -1;
            }
            return a.size - b.size;
        });

        this.infoBoxes = new Map();

        for(let b of boxes){
            let d = b.align=='left'? 1: -1;
            let x1 = b.pos[0];
            let x2 = x1 + d * 100;
            let y1 = b.pos[1] - 15;
            let y2 = y1 + 30;

            for(let b2 of boxes){

                // check if box intersects with box of b2
                if(b2.show){
                    let bx1 = b2.pos[0];
                    let bx2 = bx1 + (b2.align=='left'? 100: -100)
                    if(bx1 > bx2){
                        let t = bx1;
                        bx1 = bx2;
                        bx2 = t;
                    }
                    let by1 = b2.pos[1] - 15;
                    let by2 = by1 + 30;

                    let matchX = ( (x1 < bx2 && x1 > bx1) || (x2 < bx2 && x2 > bx1) );
                    let matchY = ( (y1 < by2 && y1 > by1) || (y2 < by2 && y2 > by1) );
                    
                    if(matchX && matchY){
                        b.show = false;
                        break;
                    }
                }else{
                    // check if box of b intersects origin of b2
                    if(y1 < b2.pos[1] && y2 > b2.pos[1] && Math.min(x1, x2) < b2.pos[0] && Math.max(x1, x2) > b2.pos[0]){
                        b.show = false;
                        break;
                    }
                }

            }

            this.infoBoxes.set(b.uid, b.show);

        }

    }


} 


let Blueprint = {
    type: Controller,
    models: {
        'geo': null
    },
    listeners: [
        (ctrl) => ( ctrl.addListener(ctrl.models['geo']) )
    ],
    properties: {
        transform: {
            position: {x: 0, y: 0}
        },
        data: {
            selected: [],
            width: 0,
            height: 0,
            projectIcon: false
        }
    },
    children: [
       (ctrl) => ( ctrl.getChildren() )
    ]
}


export default Blueprint;
export {Controller, Blueprint};

